import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function mapStateToProps(state) {
  return {
    leaveWarn: state.leaveWarn,
  };
}

function withLeaveWarn(WrappedComponent) {
  class WithLeaveWarn extends Component {
    constructor() {
      super();
      this.leaveMessage = 'warning';
      this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
      // this.handlePopState = this.handlePopState.bind(this);
    }

    componentDidMount() {
      window.addEventListener('beforeunload', this.handleBeforeUnload);
      // window.addEventListener('popstate', this.handlePopState);
    }
    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    // 離開,重整頁面
    handleBeforeUnload(event) {
      if (!this.props.leaveWarn.ignoreUnload) {
        const nodeEvent = event || window.event;
        nodeEvent.returnValue = this.leaveMessage;
        return this.leaveMessage;
      }
    }
    // TOFIX 待測試功能
    // 上下頁
    // handlePopState(event) {
    //   alert('location: ' + document.location);
    //   event.preventDefault();
    //   return false;
    // }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  WithLeaveWarn.displayName = `WithLeaveWarn(${getDisplayName(WrappedComponent)})`;
  WithLeaveWarn.propTypes = {
    leaveWarn: PropTypes.object,
  };
  return connect(mapStateToProps)(WithLeaveWarn);
}

export default withLeaveWarn;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/LeaveWarn/withLeaveWarn.js
 **/